import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/themetwo/head_37.png'
import _imports_1 from '@/assets/themetwo/icon-copy.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "head_card" }
const _hoisted_3 = { class: "id" }
const _hoisted_4 = { class: "contact" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { style: {"color":"#88f2fa"} }
const _hoisted_7 = { style: {"color":"gold"} }

import PrimaryButton from '../../components/common/primaryButton.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useUserStore } from '@/stores/user';
import { formatCurrency } from '@/utils/commonFunction';
import CarteiraView from '@/view/carteiraView/carteiraView.vue';
import { buttonClick, clickOnCard, copyID } from '@/view/profile/supportScript';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'headCard',
  setup(__props) {

const router = useRouter()
const statusRef = ref();
const userStore = useUserStore()
const name = computed(() => userStore.nickname)
const balance = computed(() => userStore.balance)
const id = computed(() => userStore.id)
const unreadMsgCount = computed(() => userStore.unreadCount)
const isPopping = ref(false)
const walletPopupRef = ref()

const onClickCard = () => clickOnCard(router, isPopping, '/sd-message')
const onCopyID = (id: any) => copyID(statusRef, id)
const onButtonClick = (type: string) => {
    if (type === 'withdraw') {
        // router.push({ path: '/sd-carteira', query: { tab: 1 } });
        walletPopupRef?.value?.openPopup(1)
    } else if (type === 'topup') {
        walletPopupRef?.value?.openPopup(0)
        // router.push({ path: '/sd-carteira', query: { tab: 0 } });
    }
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "6",
            class: "avatar"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "14",
            style: {"display":"flex","flex-direction":"column","justify-content":"center","padding-left":"5px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(name.value), 1),
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.$t('profile.id')) + " : " + _toDisplayString(id.value) + " ", 1),
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onCopyID(id.value)))
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('common.balance')), 1),
                _createElementVNode("span", _hoisted_7, " R$ " + _toDisplayString(_unref(formatCurrency)(balance.value)), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "4",
            class: "mail"
          }),
          _createVNode(_component_van_col, {
            span: "12",
            class: "withdraw_btn"
          }, {
            default: _withCtx(() => [
              _createVNode(PrimaryButton, {
                text: _ctx.$t('common.sake'),
                textColor: "#FFFFFF",
                bgColor: "#fd66b1",
                onOnClick: _cache[1] || (_cache[1] = ($event: any) => (onButtonClick('withdraw')))
              }, null, 8, ["text"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "12",
            class: "deposit_btn"
          }, {
            default: _withCtx(() => [
              _createVNode(PrimaryButton, {
                text: _ctx.$t('common.deposite'),
                textColor: "#752700",
                bgColor: "#ffc809",
                onOnClick: _cache[2] || (_cache[2] = ($event: any) => (onButtonClick('topup')))
              }, null, 8, ["text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      content: _ctx.$t('common.copied'),
      isShowSuccess: true
    }, null, 8, ["content"]),
    _createVNode(CarteiraView, {
      ref_key: "walletPopupRef",
      ref: walletPopupRef
    }, null, 512)
  ]))
}
}

})